export default function DownloadGuide() {
  const steps = [
    {
      step: '01',
      title: '访问官网',
      description: '打开浏览器访问抖阴pro官方网站，选择对应平台下载',
      icon: 'ri-global-line',
    },
    {
      step: '02',
      title: '下载安装包',
      description: 'Android用户下载APK文件，iOS用户跳转App Store获取',
      icon: 'ri-download-cloud-2-line',
    },
    {
      step: '03',
      title: '完成安装',
      description: '按照提示完成安装，Android用户需开启"允许未知来源"',
      icon: 'ri-install-line',
    },
    {
      step: '04',
      title: '开始体验',
      description: '注册或登录账号，开启您的短视频精彩之旅',
      icon: 'ri-rocket-2-line',
    },
  ];

  return (
    <section id="download" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-sm font-medium mb-4">
            下载指南
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            快速下载安装抖阴pro
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            只需四步，即可完成下载安装，开始畅享海量优质短视频内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-14">
          {steps.map((item, index) => (
            <div key={index} className="relative">
              <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
                <div className="text-5xl font-heading font-bold text-primary-200 mb-3">{item.step}</div>
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-accent-600 text-xl`}></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
              {index < 3 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-foreground-300 text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="w-full sm:w-auto px-8 py-4 rounded-xl bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-android-line text-lg"></i>
            Android版下载
          </a>
          <a
            href="#"
            className="w-full sm:w-auto px-8 py-4 rounded-xl bg-background-50 text-foreground-900 text-base font-semibold border-2 border-foreground-200 hover:border-foreground-400 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-apple-line text-lg"></i>
            iOS版下载
          </a>
        </div>

        <p className="text-center mt-6 text-sm text-foreground-500">
          支持 Android 8.0+ / iOS 14.0+ 系统 · 完全免费下载
        </p>
      </div>
    </section>
  );
}